export const armBookAppointmentCompletionWatch = (ref, watch) => {
    ref.current = watch;
};

export const settleBookAppointmentDialog = (ref, { genuineOutcome = false } = {}) => {
    const wasArmed = Boolean(ref.current);
    ref.current = null;
    return Boolean(genuineOutcome && wasArmed);
};
